/**
 * UI控件库 
 * @module UI
 */

;(function (ui,$) {

/**
 * <h3>loading 加载</h3>
 * <a href="../../ui_controls/bui.loading.html" target="_blank">demo</a>
 * <p>loading 默认引用的时候就会初始化,不想马上初始化需要使用 widget的方式  详情查看方法2</p>
 * <h5>方法</h5>
 * {{#crossLink "bui.loading/option"}}{{/crossLink}}: 获取设置参数 <br>
 * {{#crossLink "bui.loading/widget"}}{{/crossLink}}: 获取依赖控件 <br>
 * {{#crossLink "bui.loading/start"}}{{/crossLink}}: 显示加载 <br>
 * {{#crossLink "bui.loading/stop"}}{{/crossLink}}: 隐藏加载 <br>
 *  @namespace bui
 *  @class loading
 *  @constructor 
 *  @param {object} [option] 
 *     @param option.appendTo {string} [ appendTo是进度条生成的位置ID,默认在body标签下 ]
 *     @param option.width {number} [ 宽度 ]
 *     @param option.height {number} [ 高度 ]
 *     @param option.text {string} [ 加载的文本 ]
 *     @param option.onlyText {boolean} [ 是否只显示文本 ]
 *     @param option.autoClose {boolean} [ 默认true | false 是否点击自动关闭 ]
 *     @param option.display {string} [ inline ]
 *     @param option.callback {function} [ 回调 ]
 * @example
 * 
 *
        var uiLoading = bui.loading();
        //关闭进度条
        //uiLoading.stop();
 *
 */
    ui.loading = function(option){

        var id ,
            $id,
            $loading ;

        //默认配置
        var config = {
            appendTo: "",
            width: 30,     
            height: 30,    
            text:"正在加载...",
            onlyText:false,   
            mask: true,      
            autoClose: true,    
            display:"inline", 
            template: null,  
            callback: null   
        }
        
        //方法
        var module = {
            start: start,
            stop: stop,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, ui.config.loading, option );

        //引用遮罩模块
        var uiMask;

        //执行初始化
        init(param);

        //控件的初始化
        function init (option) {
            option = option || param;
            
            // loading 可以加在body标签
            $id = ui.obj(option.appendTo) || $('body');

            //option获取新参数使用
            param = module.config = option;

            render(option);

            $loading = $id.children('.'+ui.prefix('loading'));
            
            //添加遮罩
            if( option.mask ){
                uiMask = ui.mask(option);
            }
            
            bind(option);
            
            return this;
        }
        
        //模板工厂
        function template (option) {
            
                option = option || {};
            //是否传text进来
            var bool = option.text;
            var pWidth = $id.width();
            var height = bool && option.display == "block" ? ( parseInt(option.height) + 30): parseInt(option.height) ;
            var left = -(pWidth/2);
            var top = -(height/2);
            var display = option.display == "block" ? "": ui.prefix('loading-inline');

            var html = '';
                html += '<div class="'+ui.prefix('loading')+' '+display+'" style="width:'+pWidth+'px;height:'+height+'px;line-height:1;margin-left:'+ left+'px;margin-top:'+ top+'px;" >';
            if( !option.onlyText ){
                html +=     '<div class="'+ui.prefix('loading-cell')+'" style="width:'+parseFloat(option.width)+'px;height:'+parseFloat(option.height)+'px;"></div>';
            }
            //是否显示文本提醒
            if( bool ){
                html +=     '<div class="'+ui.prefix('loading-text')+'">'+ option.text +'</div>';
            }         
                html += '</div>';

            var newhtml = option && option.template ? option.template: html;

            return newhtml;
        };

        //模板渲染
        function render (option) {

            var tpl = template(option) ;

            $id.append(tpl);

            return this;
        };

        /**
         * 显示loading , 参数参考loading的初始化
         *  @method start
         *  @chainable
         *  @example 
            var uiLoading = bui.loading();
                uiLoading.start();
                
         */
        function start (option) {

            option = $.extend(true, param, option);

            stop();

            init(option);

            return this;
        }

        
        /**
         * 关闭loading
         *  @method stop
         *  @chainable
         *  @example 
            var uiLoading = bui.loading();
                uiLoading.stop();
                
         */
        function stop (option) {

            if( $loading ){

                $loading.remove();

                if( uiMask ){
                    uiMask.remove();
                }

            }
            return this;
        }

        //绑定事件
        function bind (option) {

            option = option || {};

            //会存在点透问题,需要在页面绑定mask再阻止一次
            $loading.off("click.bui").on("click.bui",function(e) {

                //是否绑定移除事件
                if( option.autoClose ){
                    stop();
                }

                //如果有回调就执行
                option.callback && option.callback.call(this,module);

                e.stopPropagation();
            })
            //会存在点透问题,需要在页面绑定mask再阻止一次
            $id.off("click.bui",'.'+ui.prefix('mask')).on("click.bui",'.'+ui.prefix('mask'),function(e) {

                //是否绑定移除事件
                if( option.autoClose ){
                    stop();
                }

                e.stopPropagation();
            })
        }
        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 mask]
         *  @example 
            
            //获取依赖控件
            var uiLoadingWidget = uiLoading.widget();
            
                
         */
        function widget(name) {
            var control = { mask: uiMask };
                
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiLoading.option();

            //获取某个参数
            var id = uiLoading.option( "appendTo" );

            //修改一个参数
            uiLoading.option( "autoClose",true );

            //修改多个参数
            uiLoading.option( {"autoClose":true} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }

        return module;
    };

    return ui;

})( bui || {}, libs );
